<template>
  <v-row justify="center">
    <v-col cols="12" md="12">
      <v-card class="card-data-person">
        <v-card-title primary-title v-html="$t('common.complete_contact')" />
        <v-card-text>
          <v-form ref="form">
            <h4 class="py-3" v-html="$t('booking.booking_form_label')" />
            <v-text-field
              v-model="profile.name"
              class="rounded-lg"
              type="text" color="info"
              :rules="[rules.required, rules.spaces, rules.letras]"
              :label="$t('booking.booking_form_label')"
              outlined dense
              data-testid="DataReserve-ProfileName"
            />
            <div v-if="branch.has_birthday_date">
              <h4 class="py-3" v-html="$t('booking.birthday_label')" />
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-xs9 min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="profile.birthday_date"
                    prepend-icon="mdi-calendar"
                    outlined dense readonly
                    v-bind="attrs" v-on="on"
                    class="rounded-lg"
                    :required="branch.required_birthday_date" :rules="branch.required_birthday_date ? [rules.required]:[]"
                  />
                </template>
                <v-date-picker
                  v-model="date"
                  :active-picker.sync="activePicker" :locale="instance.locale"
                  :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10)"
                  min="1950-01-01"
                  @change="saveBirthday"
                />
              </v-menu>
            </div>
            <div v-if="branch.has_dni">
              <h4 class="py-3" v-html="$t('booking.dni_label')" />
                <v-row  class="has-dni" dense>
                  <v-col cols="4">
                    <v-select
                      v-model="profile.dni_type"
                      :items="arrayDni"
                      item-text="shortname" item-value="value"
                      class="mr-1 rounded-lg"
                      outlined dense
                      :required="branch.required_dni"
                      :rules="branch.required_dni ? [rules.required]:[]"
                    />
                  </v-col>
                  <v-col cols="8">
                    <v-text-field
                      v-model="profile.dni"
                      class="mr-1 rounded-lg"
                      outlined dense
                      :required="branch.required_dni"
                      :rules="branch.required_dni ? [rules.required]:[]"
                    />
                  </v-col>
                </v-row>
            </div>
            <div v-if="branch.has_sex">
              <h4 class="py-3" v-html="$t('booking.sex_label')" />
              <v-select
                v-model="profile.sex"
                :items="sexs"
                class="rounded-lg"
                item-text="label" item-value="value"
                outlined dense
                :required="branch.required_sex"
                :rules="branch.required_sex ? [rules.required]:[]"
              />
            </div>
            <h4 class="py-3" v-html="$t('PREFIX')" />
            <v-autocomplete
              v-model="phoneObjectData"
              class="rounded-lg"
              color="info"
              outlined dense :label="$t('PREFIX')"
              :items="countries" item-text="label" :item-value="phoneObjectData.phone_code !== null ? phoneObjectData.phone_code : ''"
              :rules="[rules.required]" return-object
              @change="foundCountry()"
              data-testid="DataReserve-PhoneCode"
            >
              <template v-slot:item="{ item }">
                <v-row dense>
                  <v-col>
                    <span v-html="item.label" :data-testid="`DateReserve-PhoneCode-` + item.label"></span>
                  </v-col>
                </v-row>
              </template>
            </v-autocomplete>
            <h4 class="py-3" v-html="$t('checkout.buyer_phone_label')" />
            <v-text-field
              v-model="profile.phone"
              class="rounded-lg"
              type="number" color="info"
              :rules="[
                rules.required,
                rules.spaces,
                rules.min.tel,
                rules.solonumeros
              ]"
              :label="$t('checkout.buyer_phone_label')"
              outlined dense
              data-testid="DataReserve-PhoneNumber"
            />
            <h4 class="py-3" v-html="$t('booking.email_label')" />
            <v-text-field
              v-model="profile.email"
              class="rounded-lg"
              type="email" color="info"
              :rules="[rules.required, rules.spaces, rules.email]"
              :label="$t('booking.email_label')"
              outlined dense
              data-testid="DataReserve-Email"
            />
            <v-checkbox v-model="agreement" :label="labelArchisPolites" :rules="[rules.required]" @change="clickAgreement()">
              <template v-slot:label>
                <a @click.stop.prevent="openPolites()" v-html="labelArchisPolites" />
              </template>
            </v-checkbox>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-footer app class="pa-0">
      <v-container>
        <v-btn
          class="button-nextpass text-capitalize"
          large block
          color="primary"
          @click="validateForm()"
        >
          <span v-if="bookPurchaseId !== null" v-html="$t('booking.booking_label_button')" />
          <span v-else v-html="$t('booking.solicitar_reserva')"></span>
        </v-btn>
      </v-container>
    </v-footer>
    <v-overlay :value="overlay" :opacity="1" color="primary">
      <div class="text-center">
        <img
          :src="instance.preload.logo"
          class="mx-auto"
          width="200"
        /><br /><br />
        <v-progress-linear indeterminate color="yellow darken-2" /><br /><br />
        <h3
          class="font-weight-black"
          v-html="bookPurchaseId !== null ? $t('booking.booking_acepted_pay') : $t('booking.booking_acepted')"
        />
      </div>
    </v-overlay>
  </v-row>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { track } from "../../services/track-custom";
import { shoppingCart } from "../../services/shoppingCart";
import { precheckout } from "../../services/precheckout";
import { reservas } from "../../services/reservas";
import countryList from "@/assets/lists/country_code_phones.json";

export default {
  name: "DataReserve",
  props: {
    reservation: Object,
    datahora: Object,
    branch: Object,
    fecha: Object
  },
  data() {
    return {
      overlay: false,
      error: {
        profileName: false,
        profilePhone: false,
        profileEmail: false,
        profilePhoneCode: false,
        profileBirthday: false,
        profileDni: false,
        profileSex: false
      },
      validate: {
        profileName: false,
        profilePhone: false,
        profileEmail: false,
        profilePhoneCode: false,
        profileBirthday: false,
        profileDni: false,
        profileSex: false
      },
      validateBooking: false,
      rules: {
        required: v => !!v || this.$t('booking.required_field'),
        email: v => /.+@.+\..+/.test(v) || this.$t('booking.invalid_email'),
        spaces: value => {
          const s = /^[^\s]+/;
          return s.test(value) || this.$t('booking.white_spaces');
        },
        letras: value => {
          const letra = /(^[a-zA-ZÀ-ÿ\u00f1\u00d1]+)([\s]+)([^\s]+[a-zA-ZÀ-ÿ\u00f1\u00d1 ]+)$/;
          return letra.test(value) || "Completa el campo";
        },
        solonumeros: value => {
          const soloNumeros = /^\d+$/;
          return soloNumeros.test(value) || "Número no valido...";
        },
        min: { tel: v => v && v.length >= 5 || "Número incorrecto" }
      },
      purchase: {
        origin: "cluvi",
        buyer_name: "",
        buyer_phone: "",
        buyer_email: "",
        validate_contact: false,
        payment_method_original: "",
        valor_domicilio: 0,
        valor_propina: 0,
        shipping_address: "",
        shipping_address_optional: "",
        coupon_code: "",
        cash_config: { tipe: "", cash_amount: 0 },
        shipping_location: {},
      },
      agreement: true,
      countries: countryList,
      maxDay: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      dni: [
        {
          "value": "CC",
          "name": "Cedula de ciudadania",
          "shortname": "C.C"
        }
      ],
      arrayDni: [
        {
          "value": "CC",
          "name": "Cedula de ciudadania",
          "shortname": "C.C"
        },
        {
          "value": "CE",
          "name": "Cedula de extranjeria",
          "shortname": "C.E"
        },
        {
          "value": "PASSPORT",
          "name": "Pasaporte",
          "shortname": "Pasaporte"
        },
        {
          "value": "OTHER",
          "name": "Otro",
          "shortname": "Otro"
        }
      ],
      sexs: [
        { value: 'M', label: 'Masculino' },
        { value: 'F', label: 'Femenino' },
        { value: 'N/A', label: 'Prefiero no decirlo' }
      ],
      phoneObjectData: { phone_code: '' },
      activePicker: null,
      date: null,
      menu: false,
    };
  },
  computed: {
    ...mapState('bookings', ["bookPurchaseId","bookInfo"]),
    ...mapState('customer', ["supplier", "instance"]),
    ...mapState('order', ["service", "acquisitionId"]),
    ...mapState('shared', ["acquisitionId"]),
    ...mapState('profile', ["profile", "session"]),
    hasWaitenList () {
      return this.reservation.draft;
    },
    isArchis () {
      return this.instance.slug === 'archies' ? true : false;
    },
    labelArchisPolites () {
      return this.isArchis ? this.$t('common.policies_label_archis') : this.$t('common.policies_label');
    }
  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'))
    }
  },
  created() {
    this.getShoppingCartReserve();
    if (
      this.profile.name !== "" ||
      this.profile.phone !== "" ||
      this.profile.email !== "" ||
      this.profile.phone_code !== ""
    ) {
      this.reservation.name = this.profile.name;
      this.reservation.phone = this.profile.phone;
      this.reservation.email = this.profile.email;
      this.reservation.phone_code = this.profile.phone_code;
      this.purchase.buyer_name = this.profile.name;
      this.purchase.buyer_phone = this.profile.phone;
      this.purchase.buyer_email = this.profile.email;
      this.purchase.buyer_phone_code = this.profile.phone_code;
    };
    if(this.profile.phone_code && this.profile.phone_code_iso2) this.phoneObjectData = this.countries.find(country => country.iso2 === this.profile.phone_code_iso2);
    if(this.instance.country_code === 'PE') {
      this.arrayDni[0] = {
        "value": "DNI",
        "name": "Cedula de ciudadania",
        "shortname": "D.N.I"
      };
    }
  },
  methods: {
    ...mapMutations('template', ["SetLoading"]),
    ...mapMutations('bookings', [ "SetBookBanner","SetBookInfo" ]),
    getShoppingCartReserve () {
      if (this.bookPurchaseId && this.bookPurchaseId.length > 0) {
        shoppingCart.getProductsCart()
          .then(response => {
            let shoppingCart = response;
            this.reservation.idShopingCart = shoppingCart.id;
          });
      };
    },
    clickAgreement() {
      this.$emit('clickAgreement',this.agreement);
    },
    cambioPaso() {
      this.$emit("nextPass", "paso4");
    },
    bannerBook(){
      this.SetBookBanner(true)
    },
    validateForm() {
      if (this.$refs.form.validate() && this.agreement) {
        this.ValidateName();
        this.ValidatePhone();
        this.ValidateEmail();
        if(this.branch.required_birthday_date) this.validateBirthDay();
        if(this.branch.required_dni) this.validateDni();
        if(this.branch.required_sex) this.validateSex();
        this.CheckAllForm();
      } else {
        this.error.profilName = true;
        this.error.profilePhone = true;
        this.error.profileEmail = true;
        this.error.profilePhoneCode = true;
        this.CheckAllForm();
      }
    },
    CheckAllForm() {
      this.validateBooking = false;
      if (this.error.profileName) return;
      if (this.error.profilePhone) return;
      if (this.error.profileEmail) return;
      this.validateBooking = true;
      this.createReserve();
    },
    createReserve() {
      if (this.validateBooking === true) {
        this.overlay = true;
        this.reservation.hourv2 = this.datahora;
        this.reservation.date = this.fecha;
        this.reservation.name = this.profile.name;
        this.reservation.phone = this.profile.phone;
        this.reservation.email = this.profile.email;
        this.reservation.phone_code = this.profile.phone_code;
        this.reservation.session_id = this.session.id;
        this.reservation.acquisition_id = this.acquisitionId;
        this.reservation.purchase_id = this.bookPurchaseId;
        this.reservation.birthday_date = this.profile.birthday_date;
        this.reservation.dni_type = this.profile.dni_type;
        this.reservation.dni = this.profile.dni;
        this.reservation.sex = this.profile.sex;
        this.sendInfo();
      };
    },
    ValidateName() {
      this.validate.profileName = false;
      this.error.profileName = false;
      if (
        this.profile.name === null ||
        this.profile.name.length === 0 ||
        /^\s+$/.test(this.profile.name)
      ) {
        this.error.profileName = true;
      } else {
        let name = this.profile.name.trim().replace(/\s\s+/g, " ").split(" ", 2);
        if (
          name &&
          name.length === 2 &&
          name[0] !== "undefined" &&
          name[0].length > 0 &&
          name[1] !== "undefined" &&
          name[1].length > 0
        ) {
          this.validate.profileName = true;
        } else {
          this.error.profileName = true;
        };
      };
    },
    ValidatePhone() {
      this.validate.profilePhone = false;
      this.validate.profilePhoneCode = false;
      this.error.profilePhone = false;
      this.error.profilePhoneCode = false;
      if (
        this.profile.phone === null ||
        this.profile.phone.length === 0 ||
        /^\s+$/.test(this.profile.phone)
      ) {
        this.error.profilePhone = true;
      } else {
        let number = Number(this.profile.phone);
        if (this.profile.phone.length >= 5 && number) {
          this.validate.profilePhone = true;
        } else {
          this.error.profilePhone = true;
        };
      };
    },
    ValidateEmail() {
      this.validate.profileEmail = false;
      this.error.profileEmail = false;
      if (
        this.profile.email === null ||
        this.profile.email.length === 0 ||
        /^\s+$/.test(this.profile.email)
      ){
        this.error.profileEmail = true;
      }else {
        this.validate.profileEmail = true;
      };
    },
    sendInfo () {
      reservas.sendInfo(this.reservation)
        .then(response => {
          if (response) {
            this.reservation_id = response.data.id;
            this.overlay = false;
            this.SetBookInfo(response.data);
            this.reservationRedirection(response.data);
          };
        })
        .catch (error => {
          console.error(error);
        });
    },
    reservationRedirection (data) {
      let reservationFee = data.reservation_fee;
      let hasShoppinCartId = this.reservation.idShopingCart && this.reservation.idShopingCart.length ? true : false;
      if (reservationFee > 0 || hasShoppinCartId || this.hasWaitenList) this.precheckout();
      else this.goBookInfo();
    },
    goBookInfo () {
      this.$router.push({
        name: "BookInfo",
        params: {
          id: `${this.bookInfo.id}`,
          token: `${this.bookInfo.token}`,
          supplier_id: `${this.$route.params.supplier_id}`
        }
      });
    },
    precheckout () {
        this.purchase.buyer_phone_code = this.profile.phone_code;
        this.purchase.buyer_name = this.profile.name;
        this.purchase.buyer_phone = this.profile.phone;
        this.purchase.buyer_email = this.profile.email;
        this.purchase.session_id = this.session.id;
        this.purchase.reservation_id = this.reservation_id;
        this.purchase.service = this.service === "book" ? this.service : '';
        this.purchase.supplier_id = this.supplier.id;
        this.reservation.purchase = this.purchase;
        if (this.bookPurchaseId !== null) this.performPrecheckout();
        else if (this.hasWaitenList) this.cambioPaso();
        else ('There is no purchase id and it is not a waiting list');
    },
    performPrecheckout () {
      precheckout.precheckout(this.bookPurchaseId,this.purchase)
        .then(response => {
          if (response) {
            this.reservation.precheckout = response.data;
            track.trackEventBeginCheckout(this,this.instance,this.purchase,this.shoppingCart,this.shoppingCart?.purchase_product);
            this.cambioPaso();
          };
        })
        .catch(error => {
          console.error(error);
        });
    },
    saveBirthday (date) {
      this.$refs.menu.save(date);
      this.profile.birthday_date = date;
    },
    validateBirthDay() {
      this.validate.profileBirthday = false;
      this.error.profileBirthday = false;
      if(this.profile.birthday_date.length) this.validate.profileBirthday = true;
      else this.error.profileBirthday = true;
    },
    validateDni() {
      this.validate.profileDni = false;
      this.error.profileDni = false;
      if(this.profile.dni.length) this.validate.profileDni = true;
      else this.error.profileDni = true;
    },
    validateSex() {
      this.validate.profileSex = false;
      this.error.profileSex = false;
      if(this.profile.sex.length) this.validate.profileSex = true;
      else this.error.profileSex = true;
    },
    foundCountry() {
      if(this.phoneObjectData) {
        this.profile.phone_code = this.phoneObjectData.phone_code;
        this.profile.phone_code_iso2 = this.phoneObjectData.iso2;
      };
    },
    openPolites () {
      this.$emit('openPolites');
    }
  }
};
</script>

<style scoped lang="scss">
  .body-button-nextpass {
    font-family: 'Poppins', sans-serif !important;
    display: flex;
    flex-direction: column;
    height: 6rem;
    width: 100%;
    .button-nextpass {
      margin: 2rem 3rem 3rem 3rem;
      height: 3rem !important;
      border-radius: 10px !important;
    }
  }
  .card-data-person {
    font-family: 'Poppins', sans-serif !important;
    .v-card__title {
      font-weight: 900 !important;
      line-height: 1.5rem !important;
    }
  }
  .has-dni {
    display: flex;
    flex-direction: row;
  }
</style>
